import React from 'react';
import '../assets/css/about.css';

const About = () => {
    return (
        <>
            <header className="header-about home">
                <div className="opacity">
                    <div className="container text-center">
                        <h1>About </h1>
                        <div className="line-about text-center"></div>
                        <p className='mt-3'>
                        Go - Rental is an application to make it easier for users to make web and mobile based online vehicle rental orders. 
                        This application can be used anytime and anywhere.
                        </p>
                        
                    </div>
                </div>
            </header>
        </>
    );
};

export default About;